import type { CMSConfig } from '#types/config/components/cms'

export default {
  imageSize: '128',
} satisfies CMSConfig['megaMenuVisualSelector']
